// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cfa1f467","455":"c5701004","977":"7af223b5"}[chunkId] + ".chunk.js";
};